import { Config } from 'config'

const config: Partial<Config> = {
  env: 'prd',
  basePath: '/site/',
  basename: '/site',
  routerPath: '/*',
  api: {
    url: '/bff',
  },
}

export default config as Config
